import Lib from "../../../commons/lib";

export default class Service {
  static helyszinUrl = window.location.origin + "/api/helyszin/";
  static kultikUrl = window.location.origin + '/api/kultik/';

  // KIOSZK START

  static KIOSKinit(eszkozAzonosito, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.kultikUrl + 'public/kiosk/init/' + eszkozAzonosito,
      args: { requestType: 'kultik-init-get' },
    }], fnDone);
  }

  static getTimeoutMs(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "GET",
          url: Service.helyszinUrl + "public/ws/timeout",
          args: { requestType: "timeout-get" }
        }
      ],
      fnDone
    );
  }

  static deleteSession(sessionid, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "DELETE",
          url: Service.helyszinUrl + "public/ws/removesession",
          args: { requestType: "session-delete" },
          params: { id: sessionid }
        }
      ],
      fnDone
    );
  }

  // KIOSZK END

}
